import { render, staticRenderFns } from "./qqVideo.vue?vue&type=template&id=2f954a58&scoped=true&"
import script from "./qqVideo.vue?vue&type=script&lang=js&"
export * from "./qqVideo.vue?vue&type=script&lang=js&"
import style0 from "./qqVideo.vue?vue&type=style&index=0&id=2f954a58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f954a58",
  null
  
)

export default component.exports